module.exports = __webpack_public_path__ + "img/matt-boitor-1390290-unsplash.22371b61.jpg";